var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.77,
    height: 16.77,
    viewBox: "0 0 16.77 16.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.989,401.8V400H288v1.8Zm-1.5-1.2h.6a.3.3,0,0,1,0,.6h-.6a.3.3,0,1,1,0-.6Zm-1.8,0h.6a.3.3,0,1,1,0,.6h-.6a.3.3,0,0,1,0-.6Zm-1.8,0h.6a.3.3,0,0,1,0,.6h-.6a.3.3,0,1,1,0-.6Zm0,0",
    transform: "translate(-277.22 -385.027)",
    fill: "#488600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,400H10.182v1.8H0Zm0,0",
    transform: "translate(0 -385.027)",
    fill: "#488600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2,144.6a.6.6,0,1,1-.6-.6A.6.6,0,0,1,209.2,144.6Zm0,0",
    transform: "translate(-200.214 -138.61)",
    fill: "#488600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.066,118.754l.928,1.86.928-1.86a.3.3,0,0,1,.269-.166h1.8V112H144v6.588h1.8A.3.3,0,0,1,146.066,118.754ZM144.6,117.69v-.9a1.8,1.8,0,0,1,1.8-1.8h.6a1.2,1.2,0,1,1,1.2-1.2,1.2,1.2,0,0,1-1.2,1.2h.6a1.8,1.8,0,0,1,1.8,1.8v.9a.3.3,0,0,1-.3.3H144.9A.3.3,0,0,1,144.6,117.69Zm0,0",
    transform: "translate(-138.61 -107.808)",
    fill: "#488600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.4,208h-1.2a1.2,1.2,0,0,0-1.2,1.2v.6h3.593v-.6A1.2,1.2,0,0,0,178.4,208Zm0,0",
    transform: "translate(-169.412 -200.214)",
    fill: "#488600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M353.2,32.6a.6.6,0,1,1-.6-.6A.6.6,0,0,1,353.2,32.6Zm0,0",
    transform: "translate(-338.824 -30.802)",
    fill: "#488600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2,32.6a.6.6,0,1,1-.6-.6A.6.6,0,0,1,65.2,32.6Zm0,0",
    transform: "translate(-61.604 -30.802)",
    fill: "#488600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.989,0H0V6.588H1.8a.3.3,0,0,1,.268.166l.93,1.86.93-1.86a.3.3,0,0,1,.268-.166h.6v-2.7a.3.3,0,0,1,.3-.3h.9Zm-1.8,5.989H.9a.3.3,0,0,1-.3-.3v-.9a1.8,1.8,0,0,1,1.8-1.8h.6a1.2,1.2,0,1,1,1.2-1.2,1.2,1.2,0,0,1-1.2,1.2h.6a1.785,1.785,0,0,1,.7.141.3.3,0,0,1-.233.552,1.194,1.194,0,0,0-.466-.094H2.4a1.2,1.2,0,0,0-1.2,1.2v.6H4.192a.3.3,0,1,1,0,.6Zm0,0",
    fill: "#488600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.8,6.588a.3.3,0,0,1,.27.166l.928,1.86.928-1.86a.3.3,0,0,1,.269-.166h1.8V0H288V3.593h.9a.3.3,0,0,1,.3.3v2.7Zm-.125-3.442a1.788,1.788,0,0,1,.724-.152h.6a1.2,1.2,0,1,1,1.2-1.2,1.2,1.2,0,0,1-1.2,1.2h.6a1.8,1.8,0,0,1,1.8,1.8v.9a.3.3,0,0,1-.3.3H289.8a.3.3,0,0,1,0-.6h2.995v-.6a1.2,1.2,0,0,0-1.2-1.2h-1.2a1.192,1.192,0,0,0-.482.1.3.3,0,1,1-.242-.548Zm0,0",
    transform: "translate(-277.22)",
    fill: "#488600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViralIcon);
export default __webpack_public_path__ + "static/media/viral-icon.fbbd1352fb87c03cc22f5315a1b85f0d.svg";
export { ForwardRef as ReactComponent };